import { onBeforeRouteLeave } from 'src/utils/v2_helper/router';
import Error from './Error.vue'
import Loading from './Loading.vue'
import Timeout from './Timeout.vue'

export { Error, Loading, Timeout }


export const dialogQueue = [];

export function closeDialog() {
  console.log(dialogQueue);
  dialogQueue.forEach(d => {
    try {
      d?.hide()
    } catch (error) {
      console.log(error);
    }
  });
  dialogQueue.length = 0;
}

export const closeDialogMixin = {
  beforeRouteLeave(_, __, next) {
    console.log('closeDialogMixin EXEC');
    closeDialog();
    next();
  }
}
export function useCloseDialog() {
  onBeforeRouteLeave((_, __, next) => {
    console.log('useCloseDialog EXEC');
    closeDialog();
    next();
  })
}
